import { styled, Box, Grid } from '@ltvco/refresh-lib/theme';

export const EmailSearchFieldContainer = styled(Grid)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  border: `1px solid ${theme.palette.text.disabled}`,
  borderRadius: '32px',
  padding: theme.spacing(0.375, 1),
  backgroundColor: theme.palette.background.paper,
  width: '100%',
  margin: theme.spacing(4, 0),

  '&:focus-within': {
    borderColor: theme.palette.primary.main,
  },

  '&.error': {
    borderColor: theme.palette.error.main,
  },

  [theme.breakpoints.down('sm')]: {
    margin: 0,
  },
}));

export const EmailFormContainer = styled(Box)(({ theme }) => ({
  width: '100%',
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  gap: theme.spacing(2),
}));
